export default __webpack_public_path__ + "static/media/right_hover.63bab231.svg";